"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listAdmin = listAdmin;
exports.createAdmin = createAdmin;
exports.readminAdmin = readminAdmin;
exports.updateAdmin = updateAdmin;
exports.deleteAdmin = deleteAdmin;
exports.enableAdmin = enableAdmin;
exports.allAdmin = allAdmin;
exports.queryByType = queryByType;
exports.online = online;
exports.readAdmin = readAdmin;
exports.getExtList = getExtList;
exports.getUserSummary = getUserSummary;

var _request = _interopRequireDefault(require("@/utils/request"));

function listAdmin(query) {
  return (0, _request.default)({
    url: '/admin/list',
    method: 'get',
    params: query
  });
}

function createAdmin(data) {
  return (0, _request.default)({
    url: '/admin/create',
    method: 'post',
    data: data
  });
}

function readminAdmin(data) {
  return (0, _request.default)({
    url: '/admin/readmin',
    method: 'get',
    data: data
  });
}

function updateAdmin(data) {
  return (0, _request.default)({
    url: '/admin/update',
    method: 'post',
    data: data
  });
}

function deleteAdmin(data) {
  return (0, _request.default)({
    url: '/admin/delete',
    method: 'post',
    data: data
  });
}

function enableAdmin(data) {
  return (0, _request.default)({
    url: '/admin/enable',
    method: 'post',
    data: data
  });
}

function allAdmin() {
  return (0, _request.default)({
    url: '/admin/all',
    method: 'get'
  });
}

function queryByType(query) {
  return (0, _request.default)({
    url: '/admin/queryByType',
    method: 'get',
    params: query
  });
} // 在线状态报告


function online() {
  return (0, _request.default)({
    url: '/admin/status',
    method: 'get'
  });
}

function readAdmin(data) {
  return (0, _request.default)({
    url: '/admin/readAdmin',
    method: 'get',
    data: data
  });
}

function getExtList(data) {
  return (0, _request.default)({
    url: '/admin/getExtList',
    method: 'get',
    data: data
  });
}
/**
 * 获取工作量汇总
 * @param {*} data
 * @returns
 */


function getUserSummary(data) {
  return (0, _request.default)({
    url: '/admin/userSummary',
    method: 'get',
    data: data
  });
}